import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/components/pages/authentication/authentication/authentication.service';
import { InvoiceType } from 'src/app/enums/invoice-type.enum';
import { ConfigurationInvoice, InvoiceItemModel, InvoiceTemplateModel } from 'src/app/models/invoice-template.model';
import { PurchaseOrderResponse } from 'src/app/models/purchase-order.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { OrderService } from 'src/app/services/order.service';
import { PurchaseOrderService } from 'src/app/services/purchase-order.service';
import { TemplateInvoice } from 'src/app/templateInvoice/templateInvoice';

@Component({
  selector: 'app-purchases-order-active-table',
  templateUrl: './purchases-order-active-table.component.html',
  styleUrls: ['./purchases-order-active-table.component.scss']
})
export class PurchasesOrderActiveTableComponent implements OnChanges, OnInit{
  @Input() updated!: number;
  @Output() downloadOrderPdf = new EventEmitter();
  @Output() desactiveOrder = new EventEmitter();
  showingOrder: { [key: number]: boolean } = {};
  showingCancel: { [key: number]: boolean } = {};
  showingHistory: { [key: number]: boolean } = {};
  showingHistoryDetail: { [key: number]: boolean } = {};
  filterWord: string = null;
  historyDetailShowed = null;
  orders: PurchaseOrderResponse[] = [];
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  };
  viewDetials: number | null;
  viewOrder: PurchaseOrderResponse | null;
  orderShowed = null;
  historyShowed = null;
  seeingAll = false;
  userId = null;
  isHistorical: boolean;
  getClimbOrders = false;
  editingItem: number | null = null;
  loading: { [key: number]: boolean } = {};
  waitingFor = null;
  deleting: { [key: string]: boolean } = {};

  constructor(
        private purchaseOrderService: PurchaseOrderService,
        private toastService: ToastrService,
        private authService: AuthenticationService,
        private route: ActivatedRoute,
        private createService: TemplateInvoice,
        
      ) {
        this.userId = JSON.parse(authService.getCurrentUser()).id;
        var permissions = authService.getPermissions();
        if (permissions) {
          for (let i = 0; i < permissions.length; i++) {
            const element = permissions[i];
            if (element.roleId == 5017 && element.read) {
              this.seeingAll = true;
            } else if (element.roleId == 5040 && element.create) {
              this.getClimbOrders = true;
            }
          }
        }
        this.seeingAll = false;
      }
  
    ngOnInit(): void {
      this.isHistorical = this.route.snapshot.data.isHistorical;
      this.getOrders();
    }

    ngOnChanges(changes: SimpleChanges) {
    if (changes['updated']) {
      this.getOrders();
    }
  }

  getOrders() {
      this.purchaseOrderService.getOrdersActiveAndType(0).subscribe({
        next: (response: ResponseObject) => {
          this.orders = response.data;
          this.setOrders();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      })
    }

    setOrders() {
      this.orders = this.orders.sort((a, b) => Number(b.number) - Number(a.number));
      this.pagination.total = this.orders;
      this.resetPagination();
    }

    resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  onInputChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.filterWord = value;
    this.searching();
  }

  searching() {
    this.pagination.total = this.orders.filter((order) => {
      return order.id + '' == this.filterWord || order.number + '' == this.filterWord || 
      order.providerData.name.toLowerCase().includes(this.filterWord.toLowerCase()) || 
      order.user + "" == this.filterWord
    });
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  showOrder(order: PurchaseOrderResponse) {
    this.orderShowed = order;
    this.showingOrder[order.id] = true;
  }

  startEditing(itemId: number) {
    this.editingItem = itemId;
  }
  
  endEditing() {
    this.editingItem = null;
  }

  saveDeliveryDate(order: PurchaseOrderResponse, newDate: string) {
      if (!newDate) {
        return;
      }
      
      const parsedDate = new Date(newDate);
      
      this.purchaseOrderService.putOrderDeliverDate(order.id, parsedDate).subscribe({
        next: (response: any) => {
          this.getOrders();
          this.toastService.success("Fecha de Entrega actualizada correctamente", "Éxito");
        },
        error: (error) => {
          this.toastService.error("Error al actualizar la Fecha de Entrega", "Error");
        }
      });
  
      this.editingItem = null;
    }

  formatDate(date: any): Date {
    return new Date(date);
  }

  toDateInputValue(date: Date | string): string {
    if (!date) return '';
    
    const d = new Date(date);
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    return `${d.getFullYear()}-${month}-${day}`;
  }

  closeCreateOrder($event: any) {
    if ($event) {
      this.getOrders();
    }
    this.viewDetials = null;
    this.viewOrder = null;
  }

  updateCurrency($event: any){
    if (this.viewOrder) {
      this.viewOrder.currency = $event
      console.log(this.viewOrder);
      
    }
  }

  showDetails(orderId: number) {
    this.viewDetials = orderId;
    this.viewOrder = this.orders.find(o => o.id === orderId) || null;
  }

  downloadOrder(order){
    this.downloadOrderPdf.emit(order);
  }


  disableOrder(order: PurchaseOrderResponse) {
    console.log("Descativar");
  }

  resetDeletingDiv() {
    this.waitingFor = null;
  }

  deleteOrder(x: any) {
    this.waitingFor = x;
  }

  confirmDelete(order: any) {
    if (this.deleting[order.id]) {
      return;
    }
    this.deleting[order.id] = true;
    this.waitingFor = null;
    this.purchaseOrderService.putStateActiveOrder(order.id).subscribe({
      next: (response) => {
        this.getOrders();
        this.deleting[order.id] = false;
        this.desactiveOrder.emit(true);
        this.toastService.success("Orden descativada correctamente", "Exito");
      },
      error: (error: HttpErrorResponse) => {
        this.deleting[order.id] = false;
        this.toastService.error("Error al desactivar orden", "Error");
      }
    });
  }

}
